import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("g", {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M2.478 17.9631c-.4236.6658.0546 1.5369.8437 1.5369h17.3566c.7891 0 1.2673-.8712.8437-1.5369L12.8437 4.3258c-.393-.6175-1.2944-.6175-1.6874 0zm10.4765-1.0684h-1.909v-1.7368h1.909zm0-3.4736h-1.909V9h1.909z"
        })
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "SemanticWarning", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
